/*
 * @Author: your name
 * @Date: 2022-02-23 18:27:08
 * @LastEditTime: 2022-04-08 15:18:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ShopTask-goshop\src\i18n\index.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import thLocale from "./th.json";
import viLocale from "./vi"
import de from "./de"
import fr from "./fr"
import ar from "./ar"
import pt from "./pt"
import es from "./es"
import hi from "./hi"
import tw from "@/i18n/tw"
import enLocale from "./en.json";
import zhLocale from "./zh.json";
import loLocale from "./lo.json";
import verConfig from "../utils/verConfig";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale,
  },
  lo: {
    ...loLocale,
  },
  th: {
    ...thLocale,
  },
};

export const lans = [
  { name: "ລາວ", value: "lo" },
  { name: "English", value: "en" },
  { name: "简体中文", value: "zh" },
  { name: "ไทย", value: "th" },
]

const supportedLanguages = lans.map(item => item.value)

export function getLanguage() {
  // 从cookis 里面取语言
  const chooseLanguage = Cookies.get("language");
  if (!chooseLanguage || !supportedLanguages.includes(chooseLanguage)) {
    Cookies.set("language", verConfig.lan || "en");
    localStorage.setItem('language', verConfig.lan || "en")
    return verConfig.lan || "en"
  }
  // if (chooseLanguage) return chooseLanguage;
  // const language = (
  //   navigator.language || navigator.browserLanguage
  // ).toLowerCase();
  // const locales = Object.keys(messages);
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     return locale;
  //   }
  // }
  // return verConfig.lan || "en";
  return chooseLanguage || verConfig.lan || "en"
}

export function setLanguage(val) {
  Cookies.set("language", val);
  localStorage.setItem("language", val);
}

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: "en",
  messages,
});

// Keep application English authoritative while retaining shared fallback keys.
i18n.mergeLocaleMessage('en', enLocale);

export default i18n;
